import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../services/login/login.service';
import { Profile } from '../../Models/login/profile';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component';
import { ToastrModule, ToastrService } from 'ngx-toastr';
@Component({
  selector : 'app-profile',
  templateUrl : './profile.component.html',
  styleUrls : ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  loader : string = 'none';
  userId : string;
  roleID : string;
  profileDetail : Profile = new Profile();
  error : boolean;

  constructor( private router : Router, private loginService : LoginService,private snackBar : MatSnackBarComponent,private toastr: ToastrService) { 
    this.userId = localStorage.getItem('mcmt_userId');
    this.roleID = localStorage.getItem('mcmt_roleID');
  }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.profileDetails(this.userId);
  }

  profileDetails(userId : any) {
    this.loader = 'block';
      this.loginService.profileDetails(userId)
          .subscribe((resData : any) => {
            if(resData.status == true)
            {
              this.profileDetail = resData.data;
              this.loader = 'none';
            }
            else
            {
              this.toastr.error(resData.msg);
              this.loader = 'none';
            }
          }
        );
  }
}
